import { gql } from "@apollo/client";
import { BET_INFO } from "../fragments";

export const GET_BET_LIST = gql`
  query getBetListAdmin($lottery: ID) {
    getBetListAdmin(lottery: $lottery) {
      ...betInfo
    }
  }
  ${BET_INFO}
`;

export const GET_LOTTERY_LIST = gql`
  query getLotteryList {
    getLotteryList {
      id
      lotteryNo
      createdAt
    }
  }
`;
